/** Estimate hole yardage when per-hole data is unavailable (prototype parity). */
export function estimateHoleYardage(par: number, teeYardageTotal?: number | null): number {
  if (teeYardageTotal && teeYardageTotal > 0) {
    const avg = Math.round(teeYardageTotal / 18);
    if (par === 3) return Math.max(120, Math.round(avg * 0.72));
    if (par === 5) return Math.round(avg * 1.28);
    return avg;
  }
  if (par === 3) return 165;
  if (par === 5) return 525;
  return 380;
}
